//--------------------------------------------------------------------------------------------------Imports
import { useCallback, useEffect, useState } from "react";
import { RequestBitacoraEvento, ResponsePackageActivation } from "../../../types/common";
import { Button, Col, Input, Row } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import MarkdownPreviewer from "../../../common/MarkdownPreviewer";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../stores/store";
import { getGeneralData } from "../../../stores/slices/generalDataSlice";
import { eventLog, postGenerateAllCodes } from "../../../methods/Methods";
import { clearAlert, setAlert, showAlert } from "../../../stores/slices/alertSlice";
import _ from "lodash";

//-------------------------------------------------------------------------------------------------- Interface
interface CodeServicesComponentProps {
    activation: ResponsePackageActivation;
};

//-------------------------------------------------------------------------------------------------- Component
const CodeServicesComponent = (props: CodeServicesComponentProps) => {
    const { activation } = props;
    const dispatch = useDispatch<AppDispatch>();
    const { selectedContract } = useSelector(getGeneralData);
    // control
    const [state, setState] = useState<number>(0);
    const [errorCode, setErrorCode] = useState<string>("");
    // data
    const [clientId, setClientId] = useState<string>("");
    const [codeToActivate, setCodeToActivate] = useState<string>("");
    const [urlToken, setUrlToken] = useState<string>("");

    const handleCloseAlert = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const handleOnPressHire = useCallback(async () => {
        if (urlToken) {
            window.open(urlToken, "_blank");
        }
    }, [urlToken]);

    const handleRequest = useCallback(async () => {
        let message = "";
        let success = false;

        let objEventLog = {
            tipoServicio: "",
            servicio: "",
            promocion: "",
            accion: "Activacion",
            correo: ""
        } as RequestBitacoraEvento;

        await postGenerateAllCodes(activation.activationProcess, clientId)
            .then((response) => {
                if (response.data.data && response.data.data[0] && !_.isEmpty(response.data.data[0].codigo)) {
                    setCodeToActivate(response.data.data[0].codigo);
                    setUrlToken(response.data.data[0].urlToken)
                    objEventLog.tipoServicio = activation.serviceType;
                    eventLog(objEventLog, clientId);
                    setState(1);
                    success = true;
                } else {
                    setErrorCode("## " + response.data.data[0].mensaje);
                    setState(2);
                    success = true;
                }
            })
            .catch(() => {
                message = "No fue posible obtener el URL de activación. Inténtelo nuevamente más tarde.";
            });

        if (!success) {
            dispatch(setAlert({
                show: true,
                type: "ERROR",
                title: "Estimado Usuario!",
                message: message,
                onFinalize: handleCloseAlert
            }))
        }
    }, [setState, clientId, dispatch, setCodeToActivate, handleCloseAlert, activation]);

    useEffect(() => {
        if (selectedContract) {
            setClientId(selectedContract.sucursal + selectedContract.suscriptor);
        }
    }, [selectedContract, setClientId]);

    const renderStateZero = () => (
        <>
            <Col span={18}>
                <MarkdownPreviewer
                    h1Style={{
                        fontSize: 15,
                        color: "#000000",
                        fontWeight: 500
                    }}
                    h2Style={{
                        fontSize: 12,
                        color: "#707070",
                        fontWeight: 500
                    }}
                    h3Style={{
                        fontSize: 12,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                        fontWeight: 500
                    }}
                    h4Style={{
                        fontSize: 12,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                        fontWeight: 500
                    }}
                    textStyle={{
                        fontSize: 10,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                    }}
                    linkStyle={{
                        fontSize: 12,
                        color: "#000000",
                        textDecoration: "underline",
                    }}
                    mdSource={activation.mdContent}
                />
            </Col>
            <Col span={6}>
                <Button style={styles.buttonStyle} onClick={handleRequest}>
                    {activation.buttonTitle}
                </Button>
            </Col>
        </>
    );

    const renderStateOne = () => (
        <>
            <Col span={18} style={styles.mdContainer}>
                <MarkdownPreviewer
                    h1Style={{
                        fontSize: 15,
                        color: "#000000",
                        fontWeight: 500
                    }}
                    h2Style={{
                        fontSize: 12,
                        color: "#707070",
                        fontWeight: 500
                    }}
                    h3Style={{
                        fontSize: 12,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                        fontWeight: 500
                    }}
                    h4Style={{
                        fontSize: 12,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                        fontWeight: 500
                    }}
                    textStyle={{
                        fontSize: 10,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                    }}
                    linkStyle={{
                        fontSize: 12,
                        color: "#000000",
                        textDecoration: "underline",
                    }}
                    mdSource={activation.mdContentConfirm}
                />
                <Input
                    style={{ marginBottom: 20 }}
                    maxLength={47}
                    placeholder="XXXXXX"
                    value={codeToActivate}
                    disabled
                />
            </Col>
            <Col span={6} style={styles.buttonContainer}>
                <Row>
                    <Col span={24}>
                        <Button style={styles.buttonStyle} onClick={handleOnPressHire}>
                            {activation.buttonTitleConfirm}
                        </Button>
                    </Col>
                    <Col span={24}>
                        <Button style={styles.buttonCancelStyle} onClick={() => setState(0)}>
                            Cancelar
                        </Button>
                    </Col>
                </Row>
            </Col>
        </>
    );

    const renderStateTwo = () => (
        <>
            <Col span={18}>
                <MarkdownPreviewer
                    h1Style={{
                        fontSize: 15,
                        color: "#000000",
                        fontWeight: 500
                    }}
                    h2Style={{
                        fontSize: 12,
                        color: "#707070",
                        fontWeight: 500
                    }}
                    h3Style={{
                        fontSize: 12,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                        fontWeight: 500
                    }}
                    h4Style={{
                        fontSize: 12,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                        fontWeight: 500
                    }}
                    textStyle={{
                        fontSize: 10,
                        color: "#000000",
                        margin: 0,
                        padding: 0,
                    }}
                    linkStyle={{
                        fontSize: 12,
                        color: "#000000",
                        textDecoration: "underline",
                    }}
                    mdSource={errorCode}
                />
            </Col>
            <Col span={6}>
                <Button style={styles.buttonCancelStyle} onClick={() => setState(0) /* handleRequest */}>Cancelar</Button>
            </Col>
        </>
    )

    return ((state === 0) ? (
        renderStateZero()
    ) : ((state === 1) ? (
        renderStateOne()
    ) : (
        renderStateTwo()
    )));
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mdContainer: {
        paddingRight: 10,
    },
    buttonContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    buttonStyle: {
        height: 30,
        fontSize: 10,
        fontWeight: 600,
        padding: "0px 10px 0px 10px",
        borderRadius: 20,
        border: "none",
        marginBottom: 10,
        marginTop: 10,
        color: "#ffffff",
        backgroundColor: "#0055c2",
    },
    buttonCancelStyle: {
        height: 30,
        fontSize: 10,
        fontWeight: 600,
        padding: "0px 10px 0px 10px",
        borderRadius: 20,
        border: "none",
        marginBottom: 10,
        marginTop: 10,
        color: "#ffffff",
        backgroundColor: "gray",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default CodeServicesComponent;
